import Vue from 'vue';

const Route = Vue.$app.route;

const routes = [
  {
    path: '/',
    name: Route.ROOT,
    component: () => import(/* webpackChunkName: 'Console' */ '@/pages/index'),
    meta: {
      auth: true,
    },
    children: [
      {
        path: 'projects',
        name: Route.PROJECTS,
        props: true,
        component: () => import(/* webpackChunkName: 'Projects' */ '@/pages/projects/index'),
        meta: {},
      },
      {
        path: 'files',
        name: Route.FILES,
        props: true,
        component: () => import(/* webpackChunkName: 'Files' */ '@/pages/files/Index'),
        children: [
          {
            path: ':id',
            name: Route.FILE,
            props: true,
            component: () => import(/* webpackChunkName: 'Files' */ '@/pages/files/File'),
          },
        ],
      },
      {
        path: 'formations',
        name: Route.FORMATIONS,
        props: true,
        component: () => import(/* webpackChunkName: 'Formations' */ '@/pages/formations/index'),
        children: [
          {
            path: ':id',
            name: Route.FORMATION,
            props: true,
            component: () => import(/* webpackChunkName: 'Formation' */ '@/pages/formations/Formation'),
          },
        ],
      },
      {
        path: 'teams',
        name: Route.TEAMS,
        props: true,
        component: () => import(/* webpackChunkName: 'Teams' */ '@/pages/teams/index'),
        children: [
          {
            path: ':id',
            name: Route.TEAM,
            props: true,
            component: () => import(/* webpackChunkName: 'Team' */ '@/pages/teams/Team'),
          },
        ],
      },
      {
        path: 'players',
        name: Route.PLAYERS,
        props: true,
        component: () => import(/* webpackChunkName: 'Players' */ '@/pages/players/index'),
        children: [
          {
            path: ':id',
            name: Route.PLAYER,
            props: true,
            component: () => import(/* webpackChunkName: 'Player' */ '@/pages/players/player'),
          },
        ],
      },
      {
        path: 'venues',
        name: Route.VENUES,
        props: true,
        component: () => import(/* webpackChunkName: 'Venues' */ '@/pages/venues/index'),
        children: [
          {
            path: ':id',
            name: Route.VENUE,
            props: true,
            component: () => import(/* webpackChunkName: 'Venue' */ '@/pages/venues/stadium'),
          },
        ],
      },
      {
        path: 'settings',
        name: Route.SETTINGS,
        props: true,
        component: () => import(/* webpackChunkName: 'Settings' */ '@/pages/settings/Index'),
      },
      {
        path: 'users',
        name: Route.USERS,
        props: true,
        component: () => import(/* webpackChunkName: 'Users' */ '@/pages/users/index'),
        children: [
          {
            path: ':id',
            name: Route.USER,
            props: true,
            component: () => import(/* webpackChunkName: 'User' */ '@/pages/users/User'),
          },
        ],
      },
    ],
  },
  {
    path: '/project/:id',
    name: Route.PROJECT,
    props: true,
    component: () => import(/* webpackChunkName: 'Project' */ '@/pages/project/index'),
    meta: {},
    children: [
      {
        path: 'track-manager',
        name: Route.TRACK_MANAGER,
        props: true,
        component: () => import(/* webpackChunkName: 'TrackManager' */ '@/pages/project/track_manager/index'),
      },
      {
        path: 'analysis-manager',
        name: Route.ANALYSIS_MANAGER,
        props: true,
        component: () => import(/* webpackChunkName: 'AnalysisManager' */ '@/pages/project/analysis_manager/index'),
      },
      {
        path: 'game-settings',
        name: Route.GAME_SETTINGS,
        props: true,
        component: () => import(/* webpackChunkName: 'GameSettings' */ '@/pages/project/settings/index'),
      },
    ],
  },
  {
    path: '/error',
    name: Route.ERROR,
    props: true,
    component: () => import(/* webpackChunkName: 'Error' */ '@/pages/error/index'),
  },
  {
    path: '/login',
    name: Route.LOGIN,
    meta: {
      auth: false,
    },
    component: () => import(/* webpackChunkName: 'Login' */ '@/pages/login/index'),
  },

  /**
   * Redirections
   */
  {
    path: '/*',
    redirect: { name: Route.ROOT },
  },
];

// if (process.env.BUILD_CI) {
//   routes.push({
//     path: '/login',
//     name: Route.LOGIN,
//     meta: {
//       auth: false,
//     },
//     component: () => import(/* webpackChunkName: 'Login' */ '@/pages/login/index'),
//   });
// }

export default routes;
